import React, {Component} from 'react'
import PropTypes from 'prop-types'
import TableHead from "./table/TableHead"
import TableRow from "./table/TableRow"

class ListItemsQCnotMask extends Component {
    render() {
        const {outItems} = this.props

        return (
            <div className="ListItemsQCnotMask mt-3">
                <h4 className="mb-2">Các items cùng order</h4>
                <table className="table table-bordered">
                    <TableHead/>
                    <tbody>
                    {
                        outItems.map((item, index) => {
                            return <TableRow key={item._id} index={index} item={item}/>
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

ListItemsQCnotMask.propTypes = {
    outItems: PropTypes.array
}

export default ListItemsQCnotMask